{
  "templateId": "MAD",
  "primaryColor": "#EE7500",
  "secondaryColor": "#0046EB",
  "initials": "BUR"
}
